import { Component, Inject } from '@angular/core';
import { SaveCancelButtonConfig } from '@models/form/button';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { StudentInviteRequestDTO } from '@models/student';
import { ClassroomStudentService } from '@core/services/api/classroom-student.service';
import { ITeacherClassDetailDTO } from '@models/teacher-classroom';
import { NotificationService } from '@core/services/notification.service';

@Component({
  templateUrl: './student-invites-dialog.component.html',
  styleUrls: ['./student-invites-dialog.component.scss'],
})
export class StudentInvitesDialogComponent {
  buttonConfig: SaveCancelButtonConfig = new SaveCancelButtonConfig({
    save: 'Upload',
    cancel: 'Cancel',
    hasCustomCancel: true,
  });

  form: UntypedFormGroup = new UntypedFormGroup({
    file: new UntypedFormControl(null, [Validators.required]),
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public classroom: ITeacherClassDetailDTO,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private classroomStudentService: ClassroomStudentService,
    private notificationService: NotificationService,
  ) {}
  public get submitDisabled(): boolean {
    return this.form.invalid;
  }

  public submit(event: Event): void {
    const file = event.target?.['file']?.files[0];
    this.parseCSV(file);
  }

  private parseCSV(file: File): void {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const contents = e.target?.result.toString();
      const invites = contents.split('\n').flatMap((row) => {
        if (!row || row.indexOf('name') >= 0) return;
        const columns = row.split(',');
        return new StudentInviteRequestDTO({
          firstName: columns[0],
          lastName: columns[1],
          email: columns[2],
          password: columns[3],
        });
      });
      const filteredInvites = invites.filter((invite) => invite);
      this.classroomStudentService
        .sendInviteCode(this.classroom.id, filteredInvites)
        .subscribe(
          (result) => {
            this.notificationService.showSuccess([
              'Students have been added to the class',
            ]);
            this.dialogRef.close(true);
          },
          (err) => {
            this.notificationService.showError([
              'There is an issue with the file',
              'Please verify and try again',
            ]);
            this.dialogRef.close(true);
          },
        );
    };
    reader.readAsText(file);
  }
}
